import React from 'react'
import { makeStyles, Grid, Typography, Button, LinearProgress } from '@material-ui/core'
import useSWR from 'swr'

const COLOR_STATES = {
  veryHigh: '#ac222c',
  high: '#C2571A',
  medHigh: '#AA8f00',
  med: '#008040',
  medLow: '#007a7c',
  low: '#406098',
  soon: '#283e73',
}

const useStyles = makeStyles((theme) => ({
  '@keyframes opacityPulse': {
    '0%': { opacity: 0.0 },
    '50%': { opacity: 1.0 },
    '100%': { opacity: 0.0 },
  },

  textBlock: {
    margin: '2vh',
    marginTop: '4vh',
  },
  flatCircleOfTime: {
    backgroundColor: '#FFFFFF 0%',

    height: '90%',
    width: '90%',
    borderRadius: '50%',
    animation: '$opacityPulse 4s ease-out',
    animationIterationCount: 'infinite',
    opacity: '0.0',
    position: 'relative',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
  },
  outerCircle: {
    height: '60vw',
    width: '60vw',
    padding: '1.25vh',
    borderRadius: '50%',
    background: 'linear-gradient(145deg, #e6e6e6, #ffffff)',
    boxShadow: `20px 20px 60px #d9d9d9,
               -20px -20px 60px #ffffff`,
    margin: '4vh',
    position: 'relative',
  },
  innerText: {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
  },
}))

function getColorState(maxTime) {
  if (maxTime <= 1.5) {
    return 'soon'
  } else if (maxTime <= 2.5) {
    return 'low'
  } else if (maxTime <= 4) {
    return 'medLow'
  } else if (maxTime <= 5) {
    return 'med'
  } else if (maxTime <= 6) {
    return 'medHigh'
  } else if (maxTime <= 7.5) {
    return 'high'
  } else {
    return 'veryHigh'
  }
}

const fetcher = (...args) => fetch(...args).then((res) => res.json())

export default function App() {
  const classes = useStyles()

  const queryString = window.location.search
  const urlParams = new URLSearchParams(queryString)
  const clinicId = urlParams.get('c')
  const index = urlParams.get('i')
  const vindex = urlParams.get('v')

  const { data, error } = useSWR(
    process.env.REACT_APP_CLINIC_ENDPOINT + `?clinicId=${clinicId}&index=${index}&vindex=${vindex}`,
    fetcher,
    { refreshInterval: 1000 * 60 * 10 }
  )
  console.log(data)

  if (error) return <div>failed to load</div>
  if (!data)
    return (
      <div>
        <LinearProgress color='primary' />
      </div>
    )

  return (
    <Grid container direction='column' justify='center' alignItems='center'>
      <Typography color='primary' variant='h3' align='center' style={{ marginTop: '2vh' }}>
        {data.clinic.clinicName}
      </Typography>

      {vindex ? (
        <div>
          <Typography color='primary' variant='h5' sm={6} md={12} align='center' className={classes.textBlock}>
            Due to overwhelming demand and specific expiration limits of the vaccine, we are unable to provide an exact
            wait time prediction for COVID vaccines. Please wait for a text to come to the clinic – feel free to wait
            away from the clinic until then. Make sure you can arrive at the clinic within 1 hour of being texted to
            arrive.
          </Typography>
        </div>
      ) : (
        <>
          <div className={classes.outerCircle}>
            <div
              className={classes.flatCircleOfTime}
              style={{ border: `0.625rem solid ${COLOR_STATES[getColorState(data.clinic.maxTime)]}` }}
            ></div>
            <div className={classes.innerText}>
              <Typography variant='h2' color='primary' align='center'>
                {data.clinic.minTime === data.clinic.maxTime
                  ? `${data.clinic.maxTime} hrs`
                  : `${data.clinic.minTime} to ${data.clinic.maxTime} hrs`}
              </Typography>
            </div>
          </div>
          <Typography color='primary' variant='h5' sm={6} md={12} align='center' className={classes.textBlock}>
            Due to high demands, wait times may be longer than estimated. We are sorry for any inconvenience. Please
            check this page regularly for updates.
          </Typography>
        </>
      )}
    </Grid>
  )
}

// .     .       .  .   . .   .   . .    +  .
//   .     .  :     .    .. :. .___---------___.
//        .  .   .    .  :.:. _".^ .^ ^.  '.. :"-_. .
//     .  :       .  .  .:../:            . .^  :.:\.
//         .   . :: +. :.:/: .   .    .        . . .:\
//  .  :    .     . _ :::/:               .  ^ .  . .:\
//   .. . .   . - : :.:./.                        .  .:\
//   .      .     . :..|:                    .  .  ^. .:|
//     .       . : : ..||        .                . . !:|
//   .     . . . ::. ::\(                           . :)/
//  .   .     : . : .:.|. ######              .#######::|
//   :.. .  :-  : .:  ::|.#######           ..########:|
//  .  .  .  ..  .  .. :\ ########          :######## :/
//   .        .+ :: : -.:\ ########       . ########.:/
//     .  .+   . . . . :.:\. #######       #######..:/
//       :: . . . . ::.:..:.\           .   .   ..:/
//    .   .   .  .. :  -::::.\.       | |     . .:/
//       .  :  .  .  .-:.":.::.\             ..:/
//  .      -.   . . . .: .:::.:.\.           .:/
// .   .   .  :      : ....::_:..:\   ___.  :/
//    .   .  .   .:. .. .  .: :.:.:\       :/
//      +   .   .   : . ::. :.:. .:.|\  .:/|
//      .         +   .  .  ...:: ..|  --.:|
// .      . . .   .  .  . ... :..:.."(  ..)"
//  .   .       .      :  .   .: ::/  .  .::\
